import Flatpickr from "react-flatpickr";
import styled, { createGlobalStyle, css } from "styled-components";
import { getThemeFontSize, getThemeFontWeight, getThemeLineHeight, getThemeSpace } from "../helpers";
export const DatePickerContainer = styled.div `
	padding-left: ${getThemeSpace("8")};
	display: flex;
	align-items: center;
	position: relative;
	max-height: 48px;

	border: 1px solid var(--border-primary);
	border-radius: 4px;
	background-color: var(--surface-white);
	height: 48px;
	width: 100%;

	overflow: hidden;

	& > [data-testid='icon-calendar-24px'] {
		position: absolute;
		left: ${getThemeSpace("8")};

		pointer-events: none;
	}

	& > .clear-button {
		position: absolute;
		right: ${getThemeSpace("8")};
	}
`;
export const DatePickerInput = styled(Flatpickr) `
	outline: none;
	border: none;
	border-radius: 8px;
	background-color: var(--surface-white);
	padding: ${getThemeSpace("16")};

	box-sizing: border-box;
	width: 100%;
	max-height: 44px;

	transition: all 300ms ease-in-out;
	appearance: none;
	color: var(--text-primary);
	font-size: ${getThemeFontSize("14")};
	line-height: ${getThemeLineHeight("medium")};

	&::placeholder {
		color: var(--text-primary);
	}

	&.feedback-error {
		border-color: var(--border-error);
	}
`;
const DatePickerHeader = css `
	.flatpickr-months {
		& > * {
			display: flex;
			align-items: center;
			justify-content: center;

			height: 40px;

			background-color: var(--semantic-info-weak);
			padding: 0;

			.flatpickr-monthDropdown-months {
				background-color: transparent;
				padding-left: 0;
			}

			.numInput {
				padding-left: ${getThemeSpace("16")};
			}

			.flatpickr-monthDropdown-months,
			.numInput {
				font-size: ${getThemeFontSize("14")};
				font-weight: ${getThemeFontWeight("bold")};
			}
		}

		.numInputWrapper {
			background: transparent;

			.arrowUp,
			.arrowDown {
				right: -${getThemeSpace("8")};
			}
		}

		--arrow-space: ${getThemeSpace("16")};
		.flatpickr-prev-month {
			left: var(--arrow-space);
		}

		.flatpickr-next-month {
			right: var(--arrow-space);
		}

		.flatpickr-prev-month,
		.flatpickr-next-month {
			& * {
				fill: var(--semantic-info-text) !important;
			}
		}
	}
`;
const DatePickerWeeks = css `
	.flatpickr-weekdaycontainer {
		display: flex;
		align-items: center;

		background-color: var(--surface-primary);
		height: 32px;

		text-transform: uppercase;
		text-align: center;

		.flatpickr-weekday {
			color: var(--semantic-info-text);
		}
	}
`;
const DatePickerDays = css `
	.dayContainer {
		.flatpickr-day {
			--range-radius: 8px;

			border-radius: var(--range-radius);

			&:not(.prevMonthDay, .nextMonthDay) {
				color: var(--neutral-black);
			}

			&.prevMonthDay,
			&.nextMonthDay {
				color: var(--text-primary);

				&.inRange {
					color: var(--text-primary);
				}
			}

			&:hover {
				background-color: var(--semantic-info-weak);
			}

			&.today {
				border-color: var(--border-primary);
				background-color: var(--semantic-info-weak);

				color: var(--semantic-info-text);
			}

			&.startRange {
				border-radius: var(--range-radius) 0 0 var(--range-radius);

				& + .endRange {
					box-shadow: -10px 0 0 var(--surface-accent-dark);
				}

				&.endRange {
					border-radius: var(--range-radius);
				}
			}

			&.endRange {
				border-radius: 0 var(--range-radius) var(--range-radius) 0;
			}

			&.startRange,
			&.endRange,
			&.selected {
				border-color: var(--surface-accent-dark);
				background-color: var(--surface-accent-dark);

				color: var(--text-invert);
			}

			&.inRange {
				border-color: var(--surface-primary);
				border-radius: 0;
				background-color: var(--surface-primary);
				box-shadow: -5px 0 0 var(--surface-primary), 5px 0 0 var(--surface-primary);
			}
		}
	}
`;
export const DatePickerGlobalStyles = createGlobalStyle `
	.flatpickr-calendar.date-picker {
		${DatePickerHeader};

		${DatePickerWeeks};

		${DatePickerDays};
	}
`;
//# sourceMappingURL=styles.js.map